import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import getBasicDate from 'utils/dates/getBasicDate';
import { getZonedTodayDate } from 'utils/timezone';
/**
 * Formats the section fields relating to locking/unlocking for submission.
 */

export function formatSectionLockingFields(fields) {
  var lockingMode;
  if (fields.isLocked.changedValue || fields.lockingMode.changedValue) {
    if (fields.isLocked.changedValue && fields.lockingMode.defaultValue === null) {
      lockingMode = fields.lockingMode.changedValue || 'locked';
    } else {
      lockingMode = fields.lockingMode.changedValue;
    }
  } else {
    lockingMode = fields.isLocked.wasChanged ? null : undefined;
  }
  var unlockDateTime;
  if (fields.lockingMode.value === 'time' && (fields.unlockDate.wasChanged || fields.unlockTime.wasChanged || lockingMode !== undefined)) {
    var date = fields.unlockDate.value;
    if (date === null) {
      date = getBasicDate(getZonedTodayDate(fields.unlockTimezone.value));
    }
    unlockDateTime = new Date("".concat(date, "T").concat(fields.unlockTime.value.slice(0, 5), ":00.000Z"));
  }
  var unlockTimezone;
  if (lockingMode === 'time') {
    unlockTimezone = fields.unlockTimezone.value;
  } else if (fields.lockingMode.value === 'time') {
    unlockTimezone = fields.unlockTimezone.changedValue;
  }
  return {
    lockingMode: lockingMode,
    unlockDateTime: unlockDateTime,
    unlockTimezone: unlockTimezone
  };
}